import { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useSelector } from "react-redux";
import { enumUtil } from "../../../../utils/Enum";
import isNull from "../../../../utils/NullChecking";
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest";
import NotificationHandler from "../../../../utils/NotificationHandler";
import FormValidator from "../../../../utils/FormValidator";
import DeleteConfirmatiom from "../../../General/DeleteConfirmation";
import Audit from "../../../General/Audit";
import { FindSecondChild } from "../../../../utils/FindMenuOption";
import ModalHeader from "../../Shared/ModalHeader";
import ModalFooter from "../../Shared/ModalFooter";
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import Loader from "../../../shared/Loader/Loader";
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler";
import ConfirmSave from "./ConfirmSave";
const AddNewPrompt = (props) => {
    // let IsDeleteAllowed = FindSecondChild('Setup', 'Services', 'Services')?.IsDeleted
    let IsDeleteAllowed = 'true'
    // let IsEditAllowed = FindSecondChild('Setup', 'Services', 'Services')?.IsAdd
    let IsEditAllowed = 'true'
    const { isOpenNewPrompt, handleClose, promptID, onDeletePrompt } = { ...props }
    let valModal = {}
    let ValidationModal = {
        PromptNameVal: "",
        NoteTypeVal: "",
        DefaultCustomPromptVal: ""
    }
    let Prompt_Modal = {
        PromptName: null,
        DefaultCustomPrompt: "",
        NoteType: "",
        EHRTemplateID: '',
        // Category: "",
        IsActive: true
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    const [PromptID, setPromptID] = useState()
    const [PromptValidationModal, setPromptValidationModal] = useState(ValidationModal)
    const [PromptSaveUpdateModal, setPromptSaveUpdateModal] = useState({})
    const [mainPromptModal, setmainPromptModal] = useState(Prompt_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const API_URL_AiConfigurations = enumUtil.controller.AiConfigurations
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [OnPromptSave, setOnPromptSave] = useState(false)
    const [is, setIs] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState(false)
    const [noteTypeDD, setNoteTypeDD] = useState([])
    const LoadNoteTypeDD = () => {
        ServerRequestProtected(API_URL_AiConfigurations + "/eligible-note-types", 'GET',)
            .then((response) => {
                setIs(true)
                setNoteTypeDD(response)
            }).catch((error) => {
                setNoteTypeDD([])
            })
    }
    const LoadNoteTypeData = (id) => {
        return ServerRequestProtected(
            API_URL_AiConfigurations + "/default-custom-prompt" + `/${id}`,
            "GET"
        );
    };
    useEffect(() => {
        if (props.promptID != null) {
            setPromptID(props.promptID)
            setDel(true)
        } else {

            setPromptSaveUpdateModal({ ...PromptSaveUpdateModal, IsActive: 'true' })
            if (!OnPromptSave) {
                setPromptID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [])
    useEffect(() => {
        if (!isNull(PromptID) && PromptID !== '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": PromptID,
                "TableName": enumUtil.enumAPITableName.AIPromptDefinitions
            }).then((response) => {
                setIs(true)
                setIsLoading(false)
                if (!isNull(response.NoteType)) {
                    setPromptSaveUpdateModal({ ...PromptSaveUpdateModal, NoteType: response.NoteType + "", DefaultCustomPrompt: response.DefaultCustomPrompt })
                }
                // response.NoteType = DropdownValueHandler(noteTypes, response.NoteType)
                setmainPromptModal(response)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
        LoadNoteTypeDD()
    }, [PromptID])
    const handlePromptChange = (e) => {
        let { name, value } = e.target;
        // if (process.env.REACT_APP_ISUPPERCASE === "true") {
        //     value = value.toUpperCase()
        // }
        let modal = { ...mainPromptModal };
        let saveModal = { ...PromptSaveUpdateModal }
        if (name === 'IsActive') {
            modal[name] = !modal[name]
        }
        else {
            modal[name] = value;
        }
        for (var property in Prompt_Modal) {
            if (name === 'IsActive') {
                saveModal[name] = modal[name] + ""
            } else {
                saveModal[name] = value
            }
        }
        setmainPromptModal(modal)
        setPromptSaveUpdateModal(saveModal)
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainPromptModal };
        modal[name] = value
        setmainPromptModal(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainPromptModal };
        let saveModal = { ...PromptSaveUpdateModal };

        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'NoteType') {
                saveModal['EHRTemplateID'] = selectedData.value + ""
                modal['EHRTemplateID'] = selectedData.value + ""
                modal['PromptName'] = selectedData.display
                saveModal['PromptName'] = selectedData.value + ""
                setIsLoading(true)
                LoadNoteTypeData(selectedData.value)
                    .then((response) => {
                        setIsLoading(false)
                        modal['DefaultCustomPrompt'] = response.defaultCustomPrompt
                        saveModal['DefaultCustomPrompt'] = response.defaultCustomPrompt + ""
                    })
                    .catch((error) => {
                        setIsLoading(false)
                        console.log(error);
                    });
            }
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setmainPromptModal(modal)
        setPromptSaveUpdateModal(saveModal)
        return selectedData
    }
    const PromptValidation = async () => {
        let ValidationModal = {
            PromptNameVal: FormValidator(
                mainPromptModal.PromptName,
                enumUtil.enumValidationType.Required,
                'Prompt Name',
            ),
            NoteTypeVal: FormValidator(
                mainPromptModal.NoteType,
                enumUtil.enumValidationType.Required,
                'Note Type',
            ),
            DefaultCustomPromptVal: FormValidator(
                mainPromptModal.DefaultCustomPrompt,
                enumUtil.enumValidationType.Required,
                'Description ',
            ),
        }
        await setPromptValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSavePrompt = async (id, status, noteType, ConfirmSave) => {
        // If ConfirmSave is true, it means user has confirmed to save the prompt even if there's an active prompt for the same note type. In that case, we can proceed with saving without showing the confirmation popup again.
        // ALL OTHER PROPS ARE FOR THIS FUNCTION BECAUSE IT'S ALSO CALLED FROM CONFIRMATION POPUP WITH DIFFERENT PARAMS
        await PromptValidation()
        setPromptID(PromptID)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setPromptSaveUpdateModal(PromptSaveUpdateModal)
            let saveModal = {
                // TableName: enumUtil.enumAPITableName.AIPromptDefinitions,
                // ID: PromptID,
                // data: {
                //     ...PromptSaveUpdateModal,
                //     isSystemGenerated: 'false',
                //     ConfirmSave: ConfirmSave === 'true' ? 'true' : 'false',
                //     EHRTemplateID: mainPromptModal.EHRTemplateID
                // },
                ehrTemplateId: mainPromptModal.EHRTemplateID,
                defaultCustomPrompt: mainPromptModal.DefaultCustomPrompt,
                isActive: mainPromptModal.IsActive
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_AiConfigurations + "/practice-overrides  ", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.ehrTemplateId)) {
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setPromptID(response.ehrTemplateId)
                        setOnPromptSave(true)
                        onDeletePrompt()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    if (error?.response?.data.startsWith('WARN:')) {
                        setConfirmationPopup(true)
                    } else {
                        if (!isNull(error.response.data.error)) { NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error) }
                        else { NotificationHandler(error.response.data.error, enumUtil.enumtoaster.error) }
                    }
                })
        }
    }
    const SetPromptName = () => {
        if (mainPromptModal.PromptName != null && mainPromptModal.PromptName != "") {
            return (
                <p className="heading">{mainPromptModal.PromptName}</p>
            )
        } else {
            return (
                <p className="heading">New Prompt</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.AIPromptDefinitions} ID={PromptID} onClose={onDeletePrompt} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={PromptID + ""} TableName={enumUtil.enumAPITableName.AIPromptDefinitions} />
    }
    const onCloseConfirmation = () => {
        setConfirmationPopup(false)
        setOnPromptSave(true)
        onDeletePrompt()
    }
    return (
        <>
            <Modal show={isOpenNewPrompt} onHide={handleClose} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 mw-550px">
                {DeleteConfirmation}
                {AuditPopup}
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    <ModalHeader HeaderName={SetPromptName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={OnPromptSave ? onDeletePrompt : handleClose} key={'001'} Name={'CustomPrompts'} IsDeleteAllowed={IsDeleteAllowed} />
                    {PromptValidationModal.PromptNameVal}
                    <div className={PromptValidationModal.PromptNameVal ? "input mb-2 error" : "input mb-2"} >
                        <label className='text fs-12 ar-light-color '>Prompt Name</label>
                        <input
                            type="text"
                            className='form-control'
                            value={mainPromptModal.PromptName}
                            name="PromptName"
                            id="PromptName"
                            // onChange={handlePromptChange}
                            readOnly={true}
                        />
                        {PromptValidationModal.PromptNameVal}
                    </div>
                    {/* <div className="input mb-2">
                        <label className='text fs-12 ar-light-color '>Category</label>
                        <input
                            type="text"
                            className='form-control'
                            value={mainPromptModal.Category}
                            name="Category"
                            id="Category"
                            onChange={handlePromptChange}
                        />
                    </div> */}
                    <div className={PromptValidationModal.NoteTypeVal ? 'input mb-2 error' : 'input mb-2'}>
                        <label className='text fs-12 ar-light-color '> Note Type</label>
                        <SuperSearchList
                            type="client"
                            id='NoteType'
                            name='NoteType'
                            searchValue={mainPromptModal.NoteType}
                            data={noteTypeDD}
                            onChange={handleChangeDD}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            inputError={PromptValidationModal.NoteTypeVal}
                        />
                        {PromptValidationModal.NoteTypeVal}
                        {/* <input
                        type="text"
                        className='form-control fc-xs rounded-1'
                        value={mainPromptModal.NoteType}
                        name="NoteType"
                        id="NoteType"
                        onChange={handlePromptChange}
                    /> */}
                    </div>
                    <div className={PromptValidationModal.DefaultCustomPromptVal ? 'input error' : 'input '}>
                        <label className='text fs-12 ar-light-color '>Prompt</label>
                        <textarea
                            type="text"
                            rows={15}
                            className='form-control'
                            name="DefaultCustomPrompt"
                            id="DefaultCustomPrompt"
                            value={mainPromptModal.DefaultCustomPrompt}
                            onChange={handlePromptChange}
                        />
                        {PromptValidationModal.DefaultCustomPromptVal}
                    </div>
                    {/* <div className="input">
                        <p className='text ar-light-color'>Active</p>
                        <div class="pe-0 m-0 insurance_radio_btn">
                            <div class="form-check form-switch radio_button mh-unset m-0">
                                <input
                                    class="form-check-input m-0"
                                    type="checkbox"
                                    id="IsActive"
                                    name="IsActive"
                                    checked={mainPromptModal.IsActive}
                                    onChange={handlePromptChange}
                                />
                            </div>
                        </div>
                    </div> */}

                    {/* <div className='d-flex gap-1 align-items-center m-0 ar-toggle'>
                        <p className='fs-11 text font-m lh-11'>Active</p>
                        <div class="pe-0 m-0 insurance_radio_btn">
                            <div class="form-check form-switch radio_button mh-unset m-0">
                                <input
                                    class="form-check-input m-0"
                                    type="checkbox"
                                    id="IsActive"
                                    name="IsActive"
                                    checked={mainPromptModal.IsActive}
                                    onChange={handlePromptChange}

                                />
                            </div>
                        </div>
                    </div> */}
                </Modal.Body>
                <ModalFooter
                    isSaved={OnPromptSave ? onDeletePrompt : handleClose}
                    handleSave={handleSavePrompt}
                    UpdatedDate={mainPromptModal.UpdatedDate}
                    UpdatedBy={mainPromptModal.UpdatedBy}
                    ID={PromptID} IsEditAllowed={IsEditAllowed} />

                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClose}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={handleSavePrompt}>Save</button>
            </div> */}
            </Modal>
            <ConfirmSave
                confirmationPopup={confirmationPopup}
                onCloseConfirmation={onCloseConfirmation}
                promptID={promptID}
                otherData={{ IsActive: PromptSaveUpdateModal.IsActive, NoteType: PromptSaveUpdateModal.NoteType }}
                handleSaveStatus={handleSavePrompt}
            />
        </>
    )
}

export default AddNewPrompt